export default __webpack_public_path__ + "static/media/co2_orange_light.f2a9e44a.svg";